import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface SettingsOptionsStylesProps {
  isSmall: boolean
  open: boolean
}
const ANIMATION_TIME = 200

const useStyles = makeStyles<Theme, SettingsOptionsStylesProps>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    marginRight: ({ isSmall, open }) => (isSmall ? '0' : open ? '1rem' : '0'),
    border: '0.0625rem solid #F1F1F1',
    borderRadius: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0 4px 6px 0 rgba(66,81,89,0.05)',
    width: ({ isSmall, open }) => (isSmall ? '100%' : open ? '310px' : '0'),
    backgroundColor: 'white',
    transition: `all ${ANIMATION_TIME}ms ease-in-out`
  },

  titleArea: {
    display: 'flex',
    flexShrink: 0,
    width: 'calc(100% - 3.5rem)',
    maxWidth: ({ open }) => (open ? '100%' : '0'),
    padding: ({ open }) =>
      open ? '1.75rem 1.75rem 2.1rem 1.75rem' : '1.75rem 0 2.1rem 0',
    overflow: 'hidden',
    transition: `all ${ANIMATION_TIME}ms ease-in-out`
  },

  title: {
    fontSize: theme.size.xl,
    color: '#323436'
  },

  arrowButton: {
    position: 'absolute',
    top: '16px',
    right: '0',
    padding: '8px',
    cursor: 'pointer',
    transform: ({ open }) => `translateX(50%) rotate(${open ? 0 : 180}deg)`,
    transition: `all ${ANIMATION_TIME}ms ease-in-out`
  },

  options: {
    overflowY: 'hidden',
    minHeight: 'calc(100% - 9rem)',
    height: '0',
    maxWidth: '100%',

    '& > *': {
      borderTop: '0.0625rem solid #F1F1F1'
    },

    '& > :last-child': {
      borderBottom: '0.0625rem solid #F1F1F1'
    },

    '&:hover': {
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  }
}))

export default useStyles
